import type { IGridifyPaging, IResponseBase } from '@/interfaces';
import Http from '@/services/http';
import type {
	ClientResponse,
	ClientRequest,
	RenterPhoneLookupResponse,
	RenterPhoneSwapRequest,
	RenterPhoneSwapResponse,
} from './Client.dto';
import type { IGridifyQuery } from '@/models';
import type { ITJItem } from '@/interfaces/ITJ';

const http = Http.create();

export class ClientService {
	static async getClient(clientId: string) {
		const response = await http.get<IResponseBase<ClientResponse>>(`/renter/${clientId}`);
		return response.data;
	}

	static async getClientv2(clientId: string) {
		const response = await http.get<IResponseBase<ClientResponse>>(`/clients/${clientId}`);
		return response.data;
	}

	static async updateClient(clientId: string, client: ClientRequest) {
		const response = await http.patch<IResponseBase<ClientResponse>>(
			`/clients/${clientId}`,
			client,
		);
		return response.data;
	}

	static async createClient(client: ClientRequest) {
		const response = await http.post<IResponseBase<ClientResponse>>(`/renters`, client);
		return response.data;
	}

	static async validateClientEmail(email: string) {
		const response = await http.get<IResponseBase<ClientResponse>>(`/clients/`, {
			params: { email },
		});
		return response.data;
	}

	/**
	 * @param ignoreRenterId Locatário em edição. Sem ele, o backend acusava conflito com o próprio
	 * cadastro — o mesmo falso positivo que a checagem por `originalPhone` tenta contornar no front.
	 */
	static async validateClientPhone(phone: string, ignoreRenterId?: string) {
		const response = await http.get<IResponseBase<ClientResponse>>(`/clients/`, {
			params: { phone, ignoreRenterId },
		});
		return response.data;
	}

	static async getTjFiltered(renterId: string) {
		const response = await http.get<IResponseBase<ITJItem[]>>(`/clients/${renterId}/tj-filtered`);
		return response.data;
	}

	static async getRenterByPhone(phone: string) {
		const response = await http.get<IResponseBase<RenterPhoneLookupResponse>>(
			`/renter/by-phone`,
			{ params: { phone } },
		);
		return response.data;
	}

	static async swapRenterPhones(payload: RenterPhoneSwapRequest) {
		const response = await http.patch<IResponseBase<RenterPhoneSwapResponse>>(
			`/renter/phone/swap`,
			payload,
		);
		return response.data;
	}

	static async searchClients(query: IGridifyQuery) {
		const response = await http.get<IGridifyPaging<ClientResponse>>(`/renter?`, {
			params: query,
		});
		return response.data;
	}
}
